import { useState, useEffect } from 'react';
import { BasePicker } from '../shared/BasePicker';
import { pickersDataService } from '../../services/pickersDataService';
import type { Tool } from '../../types/tools';


interface ToolPickerProps {
    value: string;
    onChange: (tool: Tool | null) => void;
    label?: string;
    required?: boolean;
    className?: string;
    usageMap?: Record<string, string[]>;
}

export const ToolPicker = ({
    value,
    onChange,
    label = "Tool",
    required = false,
    className = "",
    usageMap
}: ToolPickerProps) => {
    const [tools, setTools] = useState<Tool[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadTools = async () => {
            try {
                setLoading(true);
                const fetchedTools = await pickersDataService.getAllTools();
                setTools(fetchedTools);
            } catch (error) {
                console.error('Failed to load tools:', error);
            } finally {
                setLoading(false);
            }
        };

        loadTools();
    }, []);

    return (
        <BasePicker<Tool>
            value={value}
            onChange={onChange}
            items={tools}
            config={{
                modalTitle: 'Select Tool',
                searchPlaceholder: 'Search tools...',
                emptyStateMessage: loading ? 'Loading tools...' : 'No tools available',
                noSelectionMessage: 'No tool selected',
                getItemId: (tool) => tool.id,
                getItemDisplayName: (tool) => tool.bannerText,
                usageMap
            }}
            label={label}
            required={required}
            className={className}
        />
    );
};
